import React from 'react';

import { isMobile } from '~src/utils/browser';

// Will run an event handler when you click outside the contents of the ref node
// This only works for clicks inside the checkout iframe. Use `useOutSideIframeClick` to handle external clicks
export const useOutsideClick = (
  handler: (e: MouseEvent | TouchEvent) => void,
  dependencies: ReadonlyArray<any> = []
) => {
  const ref = React.useRef() as React.MutableRefObject<any>;

  const listener = (e: MouseEvent | TouchEvent) => {
    if (ref.current && !ref.current.contains(e.target)) {
      handler(e);
    }
  };

  React.useLayoutEffect(() => {
    // Selecting text triggers a click event at the point where your cursor is when you stop selecting
    // we want it to trigger right when the user pushes down the mouse button
    if (isMobile()) {
      document.addEventListener('touchstart', listener);
    } else {
      document.addEventListener('mousedown', listener);
    }
    return () => {
      if (isMobile()) {
        document.removeEventListener('touchstart', listener);
      } else {
        document.removeEventListener('mousedown', listener);
      }
    };
  }, dependencies);

  return ref;
};

export const useMediaQuery = (query: string) => {
  const mediaQuery = window.matchMedia(query);
  const [queryMatches, setQueryMatches] = React.useState(mediaQuery.matches);
  const listener = (e: MediaQueryListEvent) => {
    setQueryMatches(e.matches);
  };

  React.useEffect(() => {
    mediaQuery.addListener(listener);
    return () => mediaQuery.removeListener(listener);
  }, []);

  return queryMatches;
};
